import {keys, pick} from 'underscore'

const PROPS = {
    /**
     * Set to true to remove padding
     */
    dense: {
        type: Boolean,
        default: false
    }
}

/**
 *  @mixin
 */
export default {
    props: PROPS,
    computed: {
        wFormFieldSetProps () {
            const vm = this
            const propKeys = keys(PROPS)

            return pick(vm, propKeys)
        }
    }
}
